
import '../css/index.scss';     // so that parcel parcels it
require('normalize.css')
var fingerprintjs2 = require('fingerprintjs2');
import 'normalize.css';
import initialize from './initialize';
import modalComponent from './modalComponent';
import jwPlayerComponent from "./jwPlayerComponent";
import exerciseContentEditor from "./exerciseContentEditor";
import challengeEditor from "./challengeEditor";
import challenge from "./challenge";
import newChallenge from "./newChallenge";
import newExercise from "./newExercise";
import countryChooser from "./countryChooser";
import challengeSearcher from "./challengeSearcher";
import allExercisesView from "./allExercisesView";
import allChallengesView from "./allChallengesView";
import initDropdown from './init_dropdown';
import initShare from './init_share';
import $ from 'cash-dom'
import m from 'mithril'
import slider16_9 from "./slider16_9";
import slider_portrait from "./slider_portrait";
import {trans, has_permission} from "./helpers";
window.$ = $;
window.m = m;

window.SPORTNETXPAGE = window.SPORTNETXPAGE || {};

window.SPORTNETXPAGE.MODALCOMPONENT = modalComponent;
window.SPORTNETXPAGE.JWPLAYERCOMPONENT = jwPlayerComponent;
window.SPORTNETXPAGE.SLIDER16_9 = slider16_9;
window.SPORTNETXPAGE.SLIDER_ATHLETES = slider_portrait;
window.SPORTNETXPAGE.CLIENTID = null;
window.SPORTNETXPAGE.EXERCISECONTENTEDITOR = exerciseContentEditor;
window.SPORTNETXPAGE.CHALLENGEEDITOR = challengeEditor;
window.SPORTNETXPAGE.CHALLENGESEARCHER = challengeSearcher;
window.SPORTNETXPAGE.CHALLENGE = challenge;
window.SPORTNETXPAGE.COUNTRYCHOOSER = countryChooser;
window.SPORTNETXPAGE.NEWCHALLENGE = newChallenge;
window.SPORTNETXPAGE.EXERCISEEDITOR = newExercise;
window.SPORTNETXPAGE.ALLEXERCISESVIEW = allExercisesView;
window.SPORTNETXPAGE.ALLCHALLENGESVIEW = allChallengesView;
window.SPORTNETXPAGE.TRANS = trans;

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function getUserFingerPrint(cb) {
    fingerprintjs2.get(function (components) {
        var values = components.map(function (component) {
            return component.value
        })
        var murmur = fingerprintjs2.x64hash128(values.join(''), 31)
        window.SPORTNETXPAGE.CLIENTID = murmur;
        if(typeof cb == 'function'){
            cb();
        }
        setCookie('fp', murmur);
    })
}

window.getUserFingerPrint = getUserFingerPrint;
SPORTNETXPAGE['initShare'] = initShare;

if (window.requestIdleCallback) {
    requestIdleCallback(getUserFingerPrint);
} else {
    setTimeout(getUserFingerPrint, 500);
}

initialize(SPORTNETXPAGE);
